// extracted by mini-css-extract-plugin
export default {"wrapper":"_D4HZ","gallery":"ha88Y","arrows":"tOvvw","slide":"bfcgt"};